export default __webpack_public_path__ + "static/media/IconTick.17ce1476.png";